<template>
  <div class="keyword-hint">
    <div class="keyword-container" ref="keywordContainer" @mousedown="startSelection" @mousemove="handleMouseMove" @mouseup="endSelection">
      <template v-for="(keyword) in sysKeys">
        <Tooltip max-width="400" :content="typeof keyword !== 'object' ? keyword : keyword.sentences.join(' ')" :key="typeof keyword !== 'object' ? `${keyword}` : `${keyword.value}`">
          <Tag
            size="medium"
            color="warning"
          >
            <div class="keyword-text">
              {{ keyword.label }}
            </div>
          </Tag>
        </Tooltip>
      </template>
      <template v-for="(keyword, index) in keywords">
        <Tooltip max-width="400" :content="keyword" :key="index">
          <Tag
            size="medium"
            color="primary"
            :class="selectKeys.includes(`${keyword}_${index}`) ? 'selected' : ''"
            :closable="closable"
            @on-close="handleClose(index)"
            :data-id="allowSelect ? `${keyword}_${index}` : ''"
          >
            <div class="keyword-text">
              {{ keyword }}
            </div>
          </Tag>
        </Tooltip>
      </template>
      <div :style="selectionBoxStyle" class="selection-box"></div>
      <div class="del-btn">
        删除：<i-switch size="small" :value="isSelecting !== 0" @on-change="delBtnChange"/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keywords: {
      type: Array,
      default: () => [],
    },
    closable: {
      type: Boolean,
      default: false,
    },
    sysKeys: {
      type: Array,
      default: () => []
    },
    allowSelect: {
      type: Boolean,
      default: true,
    }
  },
  data() {
    return {
      isSelecting: 0,
      startX: 0,
      startY: 0,
      selectionBoxStyle: {},
      rect: {},
      selectKeys: [],
      history: [],
    }
  },
  computed: {
    keywordArr() {
      if (!this.keywords) return [];
      return this.keywords.split(' ');
    }
  },
  watch: {
    keywords(val) {
      this.selectKeys = []
      this.isSelecting = 0
    }
  },
  methods: {
    handleClose(index) {
      this.history.push(this.keywords)
      const newKeyword = [...this.keywords];
      newKeyword.splice(index, 1);
      this.$emit('change', newKeyword);
      this.selectKeys = []
      this.isSelecting = 0
    },
    startSelection(e) {
      if (!this.allowSelect || this.isSelecting !== 1) return;
      this.isSelecting = 2;
      const container = this.$refs.keywordContainer;
      const rect = container.getBoundingClientRect();
      this.startX = e.clientX - rect.left // 鼠标相对于容器的 X 坐标
      this.startY = e.clientY - rect.top  // 鼠标相对于容器的 Y 坐标
      this.getSelectionBoxStyle({ x: this.startX, y: this.startY, width: 0, height: 0 })
    },
    handleMouseMove(e) {
      if (this.isSelecting === 2) {
        const container = this.$refs.keywordContainer;
        const rect = container.getBoundingClientRect();
        const endX = e.clientX - rect.left;
        const endY = e.clientY - rect.top;
        const minX = Math.min(this.startX, endX);
        const minY = Math.min(this.startY, endY);
        const width = Math.abs(endX - this.startX);
        const height = Math.abs(endY - this.startY);
        const selectKeys = []
        this.getSelectionBoxStyle({ x: minX, y: minY, width, height })
        this.keywords.forEach((keyword, index) => {
          const el = document.querySelector(`[data-id="${keyword}_${index}"]`);
          const itemRect = el.getBoundingClientRect();
          const isIntersecting = (
            itemRect.left - rect.left < minX + width &&
            itemRect.right - rect.left > minX &&
            itemRect.top - rect.top < minY + height &&
            itemRect.bottom - rect.top > minY
          );
          if (isIntersecting) {
            selectKeys.push(`${keyword}_${index}`)
          }
        });
        this.selectKeys = [...selectKeys]
      }
    },
    getSelectionBoxStyle({ x, y, width, height }) {
      this.selectionBoxStyle = {
        left: `${x}px`,
        top: `${y}px`,
        width: `${width}px`,
        height: `${height}px`,
      };
    },
    endSelection () {
      if (this.isSelecting !== 2) return;
      this.isSelecting = 1;
    },
    keydownHandler(e) {
      if (e.key === 'Backspace' || e.key === 'Delete') {
        const keys = this.selectKeys.map(key => {
          return key.split('_')[1]; 
        })
        this.history.push(this.keywords)
        const newKeyword = this.keywords.filter((_, index) => {
          return !keys.includes(index.toString());
        })
        this.$emit('change', [...newKeyword]);
        this.selectionBoxStyle = {}
        this.selectKeys = []
        this.isSelecting = this.isSelecting === 0 ? 0 : 1;
      }
      // 监听 ctrl + z
      if (e.ctrlKey && e.key === 'z') {
        if (this.history.length > 0) {
          const lastKeyword = this.history.pop();
          this.keywords = lastKeyword;
        }
      }
    },
    delBtnChange(val) {
      this.isSelecting = val ? 1 : 0
      if (!val) {
        this.selectKeys = []
      }
    },
  },
  mounted() {
    window.addEventListener('keydown', this.keydownHandler);
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.keydownHandler);
  },
}
</script>

<style lang="scss" scoped>
.tip{
	color: #ff9600;
}
.keyword-hint {
  max-height: 400px;
  overflow-y: auto;
}
.keyword-container{
	width: auto;
	background-color: #f3f3f3;
	min-height: 200px;
  // max-height: 400px;
  // overflow-y: auto;
	padding: 20px;
  padding-bottom: 50px;
  position: relative;
}
.keyword-text {
  max-width: 280px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  vertical-align: middle;
}
.selection-box {
  position: absolute;
  border: 1px dashed blue;
  background-color: rgba(0, 0, 255, 0.1);
  pointer-events: none;
}
.selected {
  background-color: #0c52e8;
  user-select: none;
}
.del-btn { 
  position: absolute;
  top: 0;
  right: 0;
}
</style>